import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  private _user: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _currentUser: any = null;

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user(value: any) {
    // Store the value
    this._currentUser = value;
    this._user.next(value);
  }

  get user(): any {
    return this._currentUser;
  }

  get user$(): Observable<any> {
    return this._user.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the current logged in user data
   */
  get(): Observable<any> {
    return this._httpClient.get<any>('api/common/user').pipe(
      tap((user) => {
        this._currentUser = user;
        this._user.next(user);
      }),
    );
  }

  /**
   * Update the user
   *
   * @param user
   */
  update(user: any): Observable<any> {
    return this._httpClient.patch<any>('api/common/user', { user }).pipe(
      map((response) => {
        this._currentUser = response;
        this._user.next(response);
      }),
    );
  }

  toggleStatus(): Observable<any> {
    return this._httpClient.post<any>(`${environment.api}/users/toggle-status`, {});
  }
}
